<div class="ib-roles">
  <div class="ib-header">
    <h3>Roles <span class="count">({{ roles.length }})</span></h3>
    <button type="button" class="add-role-btn" (click)="openCreate()">
      <i class="bi bi-plus-lg"></i> Add Role
    </button>
  </div>

  @if (isLoading) {
    <div class="ib-loading"><span class="spinner"></span> Loading roles...</div>
  } @else if (roles.length === 0) {
    <div class="ib-empty">No roles yet — create one to get started.</div>
  } @else {
    <div class="ib-role-list">
      @for (role of roles; track role.id) {
        <div class="ib-role-row">
          <div class="ib-role-name">{{ role.name }}</div>
          <div class="ib-role-pages">
            @if (role.pageNames.length === 0) {
              <span class="no-pages">No pages assigned</span>
            } @else {
              @for (page of visiblePages(role); track page) {
                <span class="page-chip">{{ page }}</span>
              }
              @if (hiddenCount(role) > 0) {
                <button type="button" class="more-toggle" (click)="toggleExpanded(role)">
                  {{ isExpanded(role) ? 'Show less' : '+' + hiddenCount(role) + ' more' }}
                </button>
              }
            }
          </div>
          @if (canEdit) {
            <button type="button" class="icon-btn" (click)="openEdit(role)">
              <i class="bi bi-pencil"></i>
            </button>
          }
        </div>
      }
    </div>
  }
</div>

@if (isOpen) {
  <app-tenant-role-wizard [title]="draft.id ? 'Edit Role' : 'Create Role'" size="lg" (closed)="closeWizard()">
    <div class="step-indicator">
      <span class="step" [class.active]="step === 1" [class.done]="step === 2">1. Pages</span>
      <span class="step-line"></span>
      <span class="step" [class.active]="step === 2">2. Operations</span>
    </div>

    @if (step === 1) {
      <div class="form-row">
        <label>Role Name</label>
        <input type="text" [(ngModel)]="draft.name" placeholder="e.g. Content Manager" />
      </div>

      <div class="pages-header">
        <span>Assign Pages</span>
        <div class="pages-actions">
          <button type="button" (click)="selectAllPages()">Select all</button>
          <button type="button" (click)="clearAllPages()">Clear all</button>
          <span class="pages-count">{{ draft.pageNames.length }} of {{ pageCatalog.length }} selected</span>
        </div>
      </div>
      <div class="pages-grid">
        @for (page of pageCatalog; track page.name) {
          <label class="page-checkbox">
            <input type="checkbox" [checked]="isPageChecked(page.name)" (change)="togglePage(page.name)" />
            {{ page.name }}
          </label>
        }
      </div>
    } @else {
      <div class="ops-cards">
        @for (page of pagesWithOperations(); track page.name) {
          <div class="ops-card" [class.disabled]="!isPageAssigned(page.name)">
            <div class="ops-card-header">
              <span>{{ page.name }}</span>
              @if (!isPageAssigned(page.name)) {
                <span class="hint">Not assigned in Step 1</span>
              } @else if (savedFlash[page.name]) {
                <span class="saved-flash"><i class="bi bi-check-circle-fill"></i> Saved</span>
              }
            </div>
            <div class="ops-chips">
              @for (op of page.operations; track op.key) {
                <label class="op-chip" [class.selected]="isOpSelected(page.name, op.key)">
                  <input
                    type="checkbox"
                    [checked]="isOpSelected(page.name, op.key)"
                    [disabled]="!isPageAssigned(page.name)"
                    (change)="toggleOp(page.name, op.key)"
                  />
                  {{ op.label }}
                </label>
              }
            </div>
            <button
              type="button"
              class="ops-save-btn"
              [disabled]="!isPageAssigned(page.name) || !isPagePending(page.name) || savingPage === page.name"
              (click)="savePageOps(page.name)"
            >
              @if (savingPage === page.name) { <span class="spinner"></span> Saving... } @else { Save }
            </button>
          </div>
        }
      </div>
    }

    <div footer>
      @if (step === 1) {
        <button type="button" class="cancel-btn" (click)="closeWizard()">Cancel</button>
        <button type="button" class="apply-btn" [disabled]="!canProceedStep1" (click)="proceedToStep2()">Next</button>
      } @else {
        <button type="button" class="apply-btn" (click)="closeWizard()">Done</button>
      }
    </div>
  </app-tenant-role-wizard>
}
